import { IAction, reducer } from "store";
import { TaskManageAction } from "store/actions";
import { DealBase, TaskCreate, TaskPreview } from "store/types";

reducer.createHandler(TaskManageAction.GetTasksSuccess, (state, { payload }: IAction<TaskPreview[]>) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    tasks: payload
  }
}));

reducer.createHandler(TaskManageAction.CreateTaskSuccess, (state, { payload }: IAction<TaskPreview>) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    tasks: [payload, ...state.taskManagment.tasks]
  }
}));

reducer.createHandler(TaskManageAction.SetCreate, (state, { payload }: IAction<TaskCreate>) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    create: payload
  }
}));

reducer.createHandler(TaskManageAction.UpdateTaskSuccess, (state, { payload }: IAction<TaskPreview>) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    tasks: state.taskManagment.tasks.map((item) => (item.id === payload.id ? payload : item))
  }
}));

reducer.createHandler(TaskManageAction.DeleteTaskSuccess, (state, { payload }: IAction<number>) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    tasks: state.taskManagment.tasks.filter((item) => item.id !== payload)
  }
}));

reducer.createHandler(TaskManageAction.ClearTasks, (state) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    tasks: []
  }
}));

reducer.createHandler(TaskManageAction.GetDealsSuccess, (state, { payload }: IAction<DealBase[]>) => ({
  ...state,
  taskManagment: {
    ...state.taskManagment,
    deals: payload
  }
}));
